import { semanticColors, type ColorToken, type ThemeName } from './colors.ts'

/** `surface-raised` -> `--color-surface-raised` (Tailwind v4's colour namespace). */
export const cssVariableName = (token: ColorToken): string => `--color-${token}`

/** The `--color-*: value` declarations for one theme. */
export function toCssVariables(theme: ThemeName): Record<string, string> {
  const out: Record<string, string> = {}
  for (const [token, value] of Object.entries(semanticColors[theme])) {
    out[cssVariableName(token as ColorToken)] = value
  }
  return out
}
